import { fromJS } from "immutable";
import * as types from "../constants";

const dataDefault = fromJS({
  appStatus: true,
  author: "",
  email: "",
  auto_publish_by_rating: 4,
  max_rev_in_page: 12,
  primary_color: "#FF5200",
  secondary_color: "#757575",
  rating_color: "#FF5200",
  background_color: "#ffffff",
  background_color_box: "#ffffff",
  title_color: "#000000",
  text_color: "#000000",
  rating_icon: "star",
  icon_reaction: "like",
  reaction_color: "#FF5200",
  review_layout: "list",
  show_like_sdk: true,
  show_un_like_sdk: true,
  type_form_rev_sdk: "popup",
  title_section: "Top Highlight Reviews",
  title_app: "Customer Reviews",
  auto_filter_location: false,
  verified_badge_status: true,
  verified_badge_color: "#757575",
  country_flag_status: true,
  country_flag_style: "square",
  write_review_button_style: "square",
  write_review_button_color: "#FF5200",
  write_review_button_text: "Write A Review",
  description_review: "Based on {number} review",
  description_reviews: "Based on {number} reviews",
  form_your_rating: "Your Rating",
  form_box_name: "Your Name",
  form_box_email: "Your Email",
  form_box_title: "Subject",
  form_box_feedback: "Your Feedback",
  form_choose_photo: "Add Photo",
  form_button_submit: "Submit Review",
  form_button_cancel: "Cancel",
  title_thank_you_text: "Thank you for your review!",
  content_thank_you_text:
    "Your review makes other customers' shopping experience better.",
  filter_text: "Filter",
  filter_five_stars_text: "5 Stars",
  filter_four_stars_text: "4 Stars",
  filter_three_stars_text: "3 Stars",
  filter_two_stars_text: "2 Stars",
  filter_one_star_text: "1 Star",
  sort_by_text: "Sort By",
  sort_by_highest_rating_text: "Highest Rating",
  sort_by_lowest_rating_text: "Lowest Rating",
  sort_by_newest_text: "Newest",
  sort_by_oldest_text: "Oldest",
  confirmed_text: "Confirmed",
  read_more_text: "more",
  date_review_color: "#757575",
  date_review_status: true,
  status_upload_image: true,
  hidden_filter: true,
  rating_on_homepage: false,
  rating_on_collection: true,
  rating_on_product: true,
  reaction_on_off: true,
  icon_rating_follow_theme: false,
  hidden_rating_null_collections: false,
  show_all_review_on_product: false,
  status: 1,
  isActiveSaveButton: false,
  first_setup: false,
  review_label: [],
  review_note_value:
    "Video will shown with maximum resolution 720p (HD), maximum frame rate 24 fps, maximum file size 50MB/video file, no sound.",
  p_like_btn_text: "Like",
  p_unlike_btn_text: "Unlike",
  form_title: "Leave A Review",
});

let result = "";

const settingsReducer = (state = dataDefault, action) => {
  switch (action.type) {
    case types.CHANGE_SETTINGS:
      result = action.payload;
      return state
        .set("isActiveSaveButton", true)
        .set(result.field, result.value);

    case types.CHANGE_SETTINGS_RATING_ICON:
      result = action.payload;
      return state
        .set("isActiveSaveButton", true)
        .set("icon_rating_follow_theme", result.fill)
        .set(result.field, result.value);

    case types.CANCEL_SAVE:
      return state.set("isActiveSaveButton", false);

    case types.GET_SETTINGS:
      return state;

    case types.GET_SETTINGS_RESULT:
      result = action.payload;
      return state
        .set("review_label", fromJS(result.review_label))
        .set("first_setup", result.first_setup)
        .set("appStatus", result.status_app)
        .set("email", result.email)
        .set("author", result.author)
        .set("p_like_btn_text", result.p_like_btn_text)
        .set("p_unlike_btn_text", result.p_unlike_btn_text)
        .set("auto_publish_by_rating", result.auto_publish_by_rating)
        .set("max_rev_in_page", result.max_rev_in_page)
        .set("show_like_sdk", result.show_like_sdk)
        .set("show_un_like_sdk", result.show_un_like_sdk)
        .set("primary_color", result.primary_color)
        .set("rating_color", result.rating_color)
        .set("background_color", result.background_color)
        .set("title_color", result.title_color)
        .set("text_color", result.text_color)
        .set("rating_icon", result.rating_icon)
        .set("review_layout", result.review_layout)
        .set("type_form_rev_sdk", result.type_form_rev_sdk)
        .set("title_section", result.title_section)
        .set("title_app", result.title_app)
        .set("background_color_box", result.background_color_box)
        .set("secondary_color", result.secondary_color)
        .set("icon_reaction", result.icon_reaction)
        .set("reaction_color", result.reaction_color)
        .set("verified_badge_status", result.verified_badge_status)
        .set("verified_badge_color", result.verified_badge_color)
        .set("country_flag_status", result.country_flag_status)
        .set("country_flag_style", result.country_flag_style)
        .set("write_review_button_style", result.write_review_button_style)
        .set("write_review_button_color", result.write_review_button_color)
        .set("write_review_button_text", result.write_review_button_text)
        .set("description_review", result.description_review)
        .set("description_reviews", result.description_reviews)
        .set("status_upload_image", result.status_upload_image)
        .set("hidden_filter", result.hidden_filter)
        .set("rating_on_homepage", result.rating_on_homepage)
        .set("rating_on_collection", result.rating_on_collection)
        .set("rating_on_product", result.rating_on_product)
        .set("reaction_on_off", result.reaction_on_off)
        .set("form_your_rating", result.form_your_rating)
        .set("form_box_name", result.form_box_name)
        .set("form_box_email", result.form_box_email)
        .set("form_box_title", result.form_box_title)
        .set("review_note_value", result.review_note_value)
        .set("form_box_feedback", result.form_box_feedback)
        .set("form_choose_photo", result.form_choose_photo)
        .set("form_button_submit", result.form_button_submit)
        .set("form_button_cancel", result.form_button_cancel)
        .set("title_thank_you_text", result.title_thank_you_text)
        .set("content_thank_you_text", result.content_thank_you_text)
        .set("icon_rating_follow_theme", result.icon_rating_follow_theme)
        .set("filter_text", result.filter_text)
        .set("filter_five_stars_text", result.filter_five_stars_text)
        .set("filter_four_stars_text", result.filter_four_stars_text)
        .set("filter_three_stars_text", result.filter_three_stars_text)
        .set("filter_two_stars_text", result.filter_two_stars_text)
        .set("filter_one_star_text", result.filter_one_star_text)
        .set("sort_by_text", result.sort_by_text)
        .set("sort_by_highest_rating_text", result.sort_by_highest_rating_text)
        .set("sort_by_lowest_rating_text", result.sort_by_lowest_rating_text)
        .set("sort_by_newest_text", result.sort_by_newest_text)
        .set("sort_by_oldest_text", result.sort_by_oldest_text)
        .set("date_review_status", result.date_review_status)
        .set("date_review_color", result.date_review_color)
        .set("confirmed_text", result.confirmed_text)
        .set("read_more_text", result.read_more_text)
        .set(
          "hidden_rating_null_collections",
          result.hidden_rating_null_collections,
        )
        .set("show_all_review_on_product", result.show_all_review_on_product)
        .set("auto_filter_location", result.auto_filter_location)
        .set("form_title", result.form_title);

    case types.UPDATE_SETTINGS:
      return state
        .set("review_label", fromJS(action.param.review_label))
        .set("email", action.param.email)
        .set("author", action.param.author)
        .set("p_like_btn_text", action.param.p_like_btn_text)
        .set("p_unlike_btn_text", action.param.p_unlike_btn_text)
        .set("auto_publish_by_rating", action.param.auto_publish_by_rating)
        .set("max_rev_in_page", action.param.max_rev_in_page)
        .set("show_like_sdk", action.param.show_like_sdk)
        .set("show_un_like_sdk", action.param.show_un_like_sdk)
        .set("primary_color", action.param.primary_color)
        .set("rating_color", action.param.rating_color)
        .set("background_color", action.param.background_color)
        .set("title_color", action.param.title_color)
        .set("text_color", action.param.text_color)
        .set("rating_icon", action.param.rating_icon)
        .set("review_layout", action.param.review_layout)
        .set("title_section", action.param.title_section)
        .set("title_app", action.param.title_app)
        .set("auto_filter_location", action.param.auto_filter_location)
        .set("background_color_box", action.param.background_color_box)
        .set("secondary_color", action.param.secondary_color)
        .set("icon_reaction", action.param.icon_reaction)
        .set("reaction_color", action.param.reaction_color)
        .set("verified_badge_status", action.param.verified_badge_status)
        .set("verified_badge_color", action.param.verified_badge_color)
        .set("country_flag_status", action.param.country_flag_status)
        .set("country_flag_style", action.param.country_flag_style)
        .set(
          "write_review_button_style",
          action.param.write_review_button_style,
        )
        .set(
          "write_review_button_color",
          action.param.write_review_button_color,
        )
        .set("write_review_button_text", action.param.write_review_button_text)
        .set("description_review", action.param.description_review)
        .set("description_reviews", action.param.description_reviews)
        .set("status_upload_image", action.param.status_upload_image)
        .set("hidden_filter", action.param.hidden_filter)
        .set("rating_on_homepage", action.param.rating_on_homepage)
        .set("rating_on_collection", action.param.rating_on_collection)
        .set("rating_on_product", action.param.rating_on_product)
        .set("reaction_on_off", action.param.reaction_on_off)
        .set("form_your_rating", action.param.form_your_rating)
        .set("form_box_name", action.param.form_box_name)
        .set("form_box_email", action.param.form_box_email)
        .set("form_box_title", action.param.form_box_title)
        .set("review_note_value", action.param.review_note_value)
        .set("form_box_feedback", action.param.form_box_feedback)
        .set("form_choose_photo", action.param.form_choose_photo)
        .set("form_button_submit", action.param.form_button_submit)
        .set("form_button_cancel", action.param.form_button_cancel)
        .set("title_thank_you_text", action.param.title_thank_you_text)
        .set("content_thank_you_text", action.param.content_thank_you_text)
        .set("icon_rating_follow_theme", action.param.icon_rating_follow_theme)
        .set("filter_text", action.param.filter_text)
        .set("filter_five_stars_text", action.param.filter_five_stars_text)
        .set("filter_four_stars_text", action.param.filter_four_stars_text)
        .set("filter_three_stars_text", action.param.filter_three_stars_text)
        .set("filter_two_stars_text", action.param.filter_two_stars_text)
        .set("filter_one_star_text", action.param.filter_one_star_text)
        .set("sort_by_text", action.param.sort_by_text)
        .set(
          "sort_by_highest_rating_text",
          action.param.sort_by_highest_rating_text,
        )
        .set(
          "sort_by_lowest_rating_text",
          action.param.sort_by_lowest_rating_text,
        )
        .set("sort_by_newest_text", action.param.sort_by_newest_text)
        .set("sort_by_oldest_text", action.param.sort_by_oldest_text)
        .set("date_review_status", action.param.date_review_status)
        .set("date_review_color", action.param.date_review_color)
        .set("confirmed_text", action.param.confirmed_text)
        .set("read_more_text", action.param.read_more_text)
        .set(
          "hidden_rating_null_collections",
          action.param.hidden_rating_null_collections,
        )
        .set(
          "show_all_review_on_product",
          action.param.show_all_review_on_product,
        )
        .set("type_form_rev_sdk", action.param.type_form_rev_sdk)
        .set("form_title", action.param.form_title);

    default:
      return state;
  }
};

export default settingsReducer;
